"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const valueIsString_1 = __importDefault(require("../../typeAssertions/valueIsString"));
const buildCallableShowFileBrowser = (args) => async ({ functionId, entryVars: { typeFile, isMediaGalery, multipleFiles, }, callbacks, executeProcesses, }) => {
    const isValidFileType = (value) => (0, valueIsString_1.default)(value)
        && [
            'allFiles',
            'audio',
            'images',
            'pdf',
            'plainText',
        ].includes(value);
    if (!isValidFileType(typeFile)) {
        executeProcesses(functionId, callbacks.errorProcess, 'Invalid typeFile');
        return;
    }
    try {
        const URIS = await args.showFileBrowser({
            typeFile,
            isMediaGalery: !!isMediaGalery,
            multipleFiles: !!multipleFiles,
        });
        const returUirs = (uris) => (uris.length < 2 ? uris[0] : uris);
        executeProcesses(functionId, callbacks.successProcess, returUirs(URIS));
    }
    catch (error) {
        executeProcesses(functionId, callbacks.errorProcess, error);
    }
};
exports.default = buildCallableShowFileBrowser;
